// Unpublished Work © 2026 Deere & Company.

import {
    SET_DELETE_CONTACT_FLOW_ACTIVE,
    HANDLE_DELETE_CONTACT_CHECKBOX_CHANGE,
    RESET_DELETE_CONTACT_FLOW,
    SET_DELETE_CONTACT_WARNING_MODAL_VISIBLE,
    RESET_CUSTOMER_PROFILE,
    SET_DELETE_CONTACTS_SUCCESS_MESSAGE_SHOWN,
    SET_DELETE_CONTACTS_SUCCESS_COUNTS
} from '../../action-list';
import {DeleteContact} from '../../state/struct/profile/delete-contact';

const setDeleteFlowActive = (state, action) => DeleteContact.update(state, {
    isDeleteBusinessContactsFlowActive: {
        $set: action.isDeleteBusinessContactsFlowActive
    },
    selectedContactIdsToDelete: {
        $set: action.isDeleteBusinessContactsFlowActive ? [] : state.selectedContactIdsToDelete
    },
    isDeleteContactWarningModalVisible: {
        $set: action.isDeleteBusinessContactsFlowActive ? state.isDeleteContactWarningModalVisible : false
    }
});

const handleDeleteContactCheckboxChange = (state, action) => {
    const {contactId} = action;
    const isAlreadySelected = state.selectedContactIdsToDelete.includes(contactId);

    return DeleteContact.update(state, {
        selectedContactIdsToDelete: {
            $set: isAlreadySelected ?
                state.selectedContactIdsToDelete.filter((id) => id !== contactId) :
                [...state.selectedContactIdsToDelete, contactId]
        }
    });
};

const setWarningModalVisible = (state, action) => DeleteContact.update(state, {
    isDeleteContactWarningModalVisible: {
        $set: action.isDeleteContactWarningModalVisible
    }
});
const setDeleteContactsSuccessMessageShown = (state, action) => DeleteContact.update(state, {
    isDeleteContactsSuccessMessageShown: {
        $set: action.isDeleteContactsSuccessMessageShown
    }
});

const setDeleteContactsSuccessCounts = (state, action) => DeleteContact.update(state, {
    successCount: {
        $set: action.successCount
    },
    errorCount: {
        $set: action.errorCount
    }
});

const resetDeleteFlow = () => new DeleteContact({});

export function deleteContactReducer(state = new DeleteContact({}), action = {}) {
    const actionHandlers = {
        [SET_DELETE_CONTACT_FLOW_ACTIVE]: setDeleteFlowActive,
        [HANDLE_DELETE_CONTACT_CHECKBOX_CHANGE]: handleDeleteContactCheckboxChange,
        [SET_DELETE_CONTACT_WARNING_MODAL_VISIBLE]: setWarningModalVisible,
        [RESET_DELETE_CONTACT_FLOW]: resetDeleteFlow,
        [RESET_CUSTOMER_PROFILE]: resetDeleteFlow,
        [SET_DELETE_CONTACTS_SUCCESS_MESSAGE_SHOWN]: setDeleteContactsSuccessMessageShown,
        [SET_DELETE_CONTACTS_SUCCESS_COUNTS]: setDeleteContactsSuccessCounts
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
